export default {
    AMPUTACAO: 1,
    CONCUSSAO: 2,
    CONTUSAO: 3,
    ENTORSE: 4,
    ESCORIACOES: 5,
    ESMAGAMENTO: 6,
    FERIMENTO_CORTE_CONTUSO_FCC: 7,
    FRATURA: 8,
    INTOX_ENVENENAMENTO: 9,
    LUXACAO: 10,
    PERFURACAO: 11,
    POLITRAUMATISMO: 12,
    QUEIMADURA_QUIMICA: 13,
    SURDEZ: 14,
    TCE: 15,
    TRAUMA: 16,
    OUTROS: 17,
}